import RequestIcon from "@iconify/icons-mdi/account-clock";
import AbsenceIcon from "@iconify/icons-mdi/account-remove";
import LeaveIcon from "@iconify/icons-mdi/bag-personal";
import BedClockIcon from "@iconify/icons-mdi/bed-clock";
import StandByIcon from "@iconify/icons-mdi/car-clock";
import FactIcon from "@iconify/icons-mdi/clipboard-text-clock-outline";

interface MyTimeEvent {
  state?: string;
  myTimeType?: string;
  timeDataTypeCode?: string;
}

export const useMyTimeIcon = (event: MyTimeEvent) => {
  let icon = FactIcon;

  if (event.state && event.state === "requested") {
    icon = RequestIcon;
  }

  if (event.myTimeType === "STAND_BY_CALL") {
    icon = StandByIcon;
  }

  if (event.myTimeType === "LEAVE") {
    icon = LeaveIcon;
  }

  if (event.myTimeType === "ABSENCE") {
    icon = AbsenceIcon;
  }

  if (event.state && event.state === "approved") {
    icon = RequestIcon;
  }

  if (event.myTimeType === "OVERTIME" && event.timeDataTypeCode === "Tö") {
    icon = RequestIcon;
  }

  if (
    event.myTimeType === "WORKING_TIME" &&
    (event.state === "approved" || event.state === "requested")
  ) {
    icon = FactIcon;
  }

  if (event.myTimeType === "ON_CALL") {
    icon = BedClockIcon;
  }

  return icon;
};

export default useMyTimeIcon;
